import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ApiService } from "src/app/core/services";
import { ViewEncapsulation } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "sv-dynamic-page",
  templateUrl: "./dynamic-page.component.html",
  styleUrls: ["./dynamic-page.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DynamicPageComponent implements OnInit {
  slug: string = "";
  pageContent: any = null;
  pageContentBody: any = null;
  loading: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (evt) => {
        if (evt instanceof NavigationEnd) {
          let url = evt.url;
          if (url.search("/page/") !== -1) {
            this.slug = url.replace("/page/", "");
            this.getWPPage(this.slug);
          }

          return;
        }
      });

    const { params } = this.activatedRoute.snapshot;
    if (params.id) {
      this.slug = params.id;
      this.getWPPage(this.slug);
    }
  }

  async getWPPage(slug) {
    this.pageContent = null;
    this.loading = true;
    let route = this.checkRoute();

    try {
      const { status_code, result } = await this.apiService
        .get("/wp/" + route + slug)
        .toPromise();

      if (status_code && status_code === 200 && result) {
        this.loading = false;
        this.pageContent = result;
        let body = this.pageContent.content;
        this.pageContentBody = this.sanitizer.bypassSecurityTrustHtml(body);
      }
    } catch (error) {
      this.loading = false;
      throw error;
    }
  }

  checkRoute() {
    let pageRoute = this.router.url.search("/page/");
    if (pageRoute !== -1) {
      return "page/";
    }

    let newsRoute = this.router.url.search("/news/");
    if (newsRoute !== -1) {
      return "news/";
    }
  }
}
